module.exports = __webpack_public_path__ + "img/taxLogo.93251293.webp";